<sis-tiny-badge [variant]="_variant" >
  {{'STUDENT_APPLICATIONS.STATE.' + _state | translate}}
</sis-tiny-badge>
